// Function loadshopListingByCategoryBlock loads the shopListingByCategoryBlock class by dynamically importing the js on demand if needed

export function loadShopListingByCategoryBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-listing-by-category-block-chunk" */ '../widgets/shopListingByCategoryBlock').then(wg => {

		const { ShopListingByCategoryBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopListingByCategoryBlock"]');

		if(!$wg) {
			// console.info('ShopListingByCategoryBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopListingByCategoryBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopListingByCategoryBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopListingByCategoryBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopListingByCategoryBlock widget');

}
